@if ((isAllowed$ | async) && !jobId) {
<button
        mat-raised-button
        (click)="openAtmDialog()"
        class="standard-position">ATM</button>
}
@else {
<button
        mat-button
        (click)="openAtmDialog()">ATM</button>
}